// The backend's metadata.reason when another employee in the organization already has the
// personnummer being saved.
export const PERSONAL_IDENTITY_NUMBER_TAKEN = 'personalIdentityNumberTaken';

export const personalIdentityNumberTakenMessage =
  'Personnumret används redan av en annan medarbetare.';
